import React from "react";
import LoadingComponent from "../loading-component";

export default function Button({
  onClick,
  className,
  value,
  icon,
  type = "submit",
  iconPos = "left",
  disabled = false,
  name = "button",
  loading = false,
  id = "",
}) {
  return (
    <button
      name={name}
      id={id}
      icon={icon}
      disabled={disabled || loading ? true : false}
      type={type}
      className={`rounded-md font-bold flex gap-1 justify-center items-center ${
        disabled || loading
          ? "bg-secondary-buttonGray"
          : "bg-primary-primaryYellow"
      } ${
        disabled || loading
          ? "text-secondary-lightestGray"
          : "text-secondary-darkGray"
      } ${className}`}
      onClick={onClick}
    >
      {loading && <LoadingComponent />}
      {icon && iconPos === "left" && <i className={icon}></i>}
      <p className="my-auto">{value?.toString().toUpperCase()}</p>
      {icon && iconPos === "right" && <i className={icon}></i>}
    </button>
  );
}
